/**
 * Created by Administrator on 2017/10/30.
 */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";
declare var alertify: any;
@Component({
  templateUrl: "./informMessage.html",
})
export class InformMessage implements OnInit {
  constructor(private router: Router, private http: HttpService) {}

  private data: any = {};
  private page = { pageNumber: 1, pageSize: 10 };
  private messageData: Array<any> = [];
  private noticeData: Array<any> = [];
  private discountsData: Array<any> = [];

  async ngOnInit() {
    let data = await this.http.getData(API.noticeAndDiscounts, {
      pageNumber: this.page.pageNumber - 1,
      pageSize: this.page.pageSize,
    });
    let typeData = await this.http.getData(API.getNoticeAndDiscountsDetailType);
    this.data = data.data;
    this.messageData = typeData.data.messageData;
    this.noticeData = typeData.data.noticeData;
    this.discountsData = typeData.data.discountsData;
    for (let item of this.messageData) {
      for (let ele of this.data.content) {
        if (item.value == ele.messageType) {
          ele.messageLabel = item.labelEn;
        }
      }
    }
    for (let item of this.noticeData) {
      for (let ele of this.data.content) {
        if (item.value == ele.noticeType) {
          ele.noticeLabel = item.labelEn;
        }
      }
    }
    for (let item of this.discountsData) {
      for (let ele of this.data.content) {
        if (item.value == ele.discountsType) {
          ele.discountsLabel = item.labelEn;
        }
      }
    }
  }

  private getData(): void {
    this.http
      .getData(API.noticeAndDiscounts, {
        pageNumber: this.page.pageNumber - 1,
        pageSize: this.page.pageSize,
      })
      .then((res) => {
        this.data = res.data;
      });
  }

  private editCategory(id: number): void {
    this.router.navigate(["index/informMessage", id]);
  }

  private deleteCategory(id: number): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.noticeAndDiscounts + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }

  private postData: any = [];

  public isLoading: boolean = false;
  private push(id: any): void {
    this.isLoading = true;
    this.http
      .postData(API.informmessagePushAll + "?" + "id" + "=" + id, this.postData)
      .then((res) => {
        let data = res;
        this.isLoading = false;
        if (data.status.code == 0 || data.status.code == "0") {
          alertify.success(data.status.message);
        } else {
          alertify.error(data.status.message);
        }
      });
  }
  //成员推送
  private memberPush(id: any): void {
    this.isLoading = true;
    this.http
      .postData(API.informmessagePush + "?" + "id" + "=" + id, this.postData)
      .then((res) => {
        let data = res;
        this.isLoading = false;
        if (data.status.code == 0 || data.status.code == "0") {
          alertify.success(data.status.message);
        } else {
          alertify.error(data.status.message);
        }
      });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/message/informMessage.component.ts